// Google reCAPTCHA Site Key
// Replace with your actual site key from https://www.google.com/recaptcha/admin
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LenHRcsAAAAAGCORQG26HZjEuvfJVieACS9Lb-p';

